import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DeleteConfirmationModalProps } from '../types/types';

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  taskName,
  isDeleting
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="task-modal-elevated"
      backdropClassName="task-modal-elevated-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete the task <strong>"{taskName}"</strong>
          ?
        </p>
        <p className="text-danger mb-0">This action cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete Task'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
